import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchAnnouncementData } from "../redux/slice/announcementPage"
import { retrunAssets } from "../utils/getAssets"
import AnimatedPage from "../components/animatedPage"
import Banner from "../components/banner/banner"
import Announcements from "../sections/announcement"

const Announcement = () => {

    const dispatch = useDispatch()
    const state = useSelector(state => state.announcement)

    useEffect(() => {
        dispatch(fetchAnnouncementData("student-hub/announcements/"))
    }, [dispatch])


    const announcement = state?.data?.properties

    const title = announcement?.title
    const bg = announcement?.backgroundImage != null ? retrunAssets(announcement.backgroundImage[0].url) : ""
    const announcementItems = announcement?.contents?.items?.map((item=>{
        const itemData = item?.content?.properties
        return {
            title: itemData?.title,
            content: itemData?.content?.markup,
            date: itemData?.publishedOn,
            img: itemData?.leadingImage != null ? retrunAssets(itemData.image[0].url) : "https://unitendev.blob.core.windows.net/mysitestorage/media/ywchnn3y/featured-uniten-announcement.jpg",
        }
    }))


    return (
        <AnimatedPage>
            <Banner text={title} bg={bg} />
            <Announcements announcements={announcementItems} />
        </AnimatedPage>
    )
}

export default Announcement